/**
 * This custom hook returns if the cookies should be disabled or not (depending on the type of event and the
 * environment variables).
 */
function useAreCookiesDisabled() {
  return import.meta.env.VITE_COOKIE_EVENT_DISABLED === 'true';
}

export default useAreCookiesDisabled;
